export const units = [
  { name: "Unit", unit: "unit" },
  { name: "Piece", unit: "piece" },
  { name: "Teaspoon", unit: "tsp" },
  { name: "Tablespoon", unit: "tbsp" },
  { name: "Fluid Ounce", unit: "fl oz" },
  { name: "Cup", unit: "cup" },
  { name: "Milliliter", unit: "ml" },
  { name: "Liter", unit: "l" },
  { name: "Ounce", unit: "oz" },
  { name: "Pound", unit: "lb" },
  { name: "Gram", unit: "g" },
  { name: "Kilogram", unit: "kg" },
  { name: "Slice", unit: "slice" },
  { name: "Clove", unit: "clove" },
];
